// Regex estricto que soporta el Codice Fiscale normal y con Omocodía (letras en campos numéricos)
const CF_REGEX = /^[A-Z]{6}[A-Z\d]{2}[A-EHLMPRSTZ][A-Z\d]{2}[A-Z][A-Z\d]{3}[A-Z]$/i;
const PIVA_REGEX = /^\d{11}$/;

export function validatePartitaIVA(value: string): boolean {
  const clean = value.trim();
  if (!PIVA_REGEX.test(clean)) return false;

  // Validación oficial: Los dígitos del 8 al 10 corresponden al código de provincia (001-100, 201, 301)
  const officeCode = parseInt(clean.substring(7, 10), 10);
  if ((officeCode < 1 || officeCode > 100) && officeCode !== 201 && officeCode !== 301) {
    return false;
  }

  // Algoritmo de Luhn
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    let n = parseInt(clean[i], 10);
    if (i % 2 === 1) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
  }

  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === parseInt(clean[10], 10);
}

export function validateCodiceFiscale(cf: string): boolean {
  const clean = cf.toUpperCase().trim();
  if (!CF_REGEX.test(clean)) return false;

  // Diccionarios oficiales de conversión para caracteres pares e impares
  const odd: Record<string, number> = {
    0: 1, 1: 0, 2: 5, 3: 7, 4: 9, 5: 13, 6: 15, 7: 17, 8: 19, 9: 21,
    A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21,
    K: 2, L: 4, M: 18, N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14,
    U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23
  };

  const even: Record<string, number> = {
    0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9,
    A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9,
    K: 10, L: 11, M: 12, N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18,
    T: 19, U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25
  };

  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const c = clean[i];
    sum += i % 2 === 0 ? odd[c] : even[c];
  }

  const expected = String.fromCharCode((sum % 26) + 65); // 65 es 'A'
  return expected === clean[15];
}

export function validateItalianId(value: string): boolean {
  if (!value) return false;
  const clean = value.toUpperCase().trim();

  // Evaluamos de forma independiente sin romper los caracteres alfanuméricos
  return validatePartitaIVA(clean) || validateCodiceFiscale(clean);
}
